import { getPageSize } from "./selectors";

const getNextPageNumber = ({ offset: { upper } }) =>
  Math.floor((upper + 1) / getPageSize()) + 1;

export default getNextPageNumber;
